module.exports = __webpack_public_path__ + "img/vi.aa4c7c49.png";